import React from 'react';

export const InputField = ({ input, label, type, required, meta: { touched, error } }) => (
  <div className={`sd-line-input ${required && 'sd-line-input--required'} ${touched && error && 'sd-line-input--invalid'}`}>
    <label className="sd-line-input__label">{label}</label>
    <input className="sd-line-input__input" type={type} {...input} autoComplete="off" />
    {touched && error && <div className="sd-line-input__message">{error}</div>}
  </div>
);
